(function () {
  angular.module('webremote.monitoring', [])
})()

require('./tabs/system/controller')
require('./tabs/fm/controller')
require('./tabs/dataWatch/controller')

require('./controller_tabs')
